<div class="d-flex flex-column home-wrapper">
  <div class="inner-home">
    <app-header-bar [dashboardUrl]="dashboardUrl"></app-header-bar>
    <div class="home">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
